var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAchievementsBg = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 1008,
  height: 684,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#achievements-bg_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#00000000",
  d: "M0 0h1008v684H0z"
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.05
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#achievements-bg_svg__b)",
  fillRule: "evenodd",
  d: "M660.823 417.267c8.125-64.551-34.896-97.096-49.719-93.124-6.644 1.78-8.539 7.584-9.079 9.239l-.071.215c-.522 1.541-7.578 20.55-11.542 30.172-6.056 15.068-1.448 35.87 1.613 44.387 9.955 24.598 31.964 32.675 41.724 33.64-.206 3.416 1.029 11.396 1.672 14.958-8.657-4.403-22.161-7.134-27.832-7.949-24.146-3.614-27.574 7.544-26.269 13.575.815 1.649 2.31 13.854 2.956 19.75 1.785 17.824 15.464 36.786 22.08 44.039 22.537 22.721 51.633 17.134 63.364 11.501.467 1.742 6.307 8.426 9.169 11.549-7.767 1.708-19.726 5.441-24.734 7.095-24.111 9.075-21.639 22.138-17.389 27.536 5.423 5.24 8.328 7.849 10.321 9.64 2.178 1.957 3.267 2.935 5.364 5.299 10.797 10.646 26.826 19.89 35.638 23.131 34.386 8.341 57.419-12.428 64.638-23.855l3.549 1.599 23.64 88.224-13.516 3.622c-7.465 2-11.896 9.667-9.898 17.125s9.67 11.882 17.134 9.882l209.279-56.076c7.465-2 11.896-9.667 9.898-17.125s-9.67-11.882-17.134-9.882l-12.644 3.388-23.674-88.352 2.152-2.991c11.965 6.287 42.298 12.757 67.907-11.659 6.01-7.213 15.27-23.233 19.3-37.851.63-3.095 1.08-4.488 1.99-7.271.83-2.547 2.04-6.26 4.12-13.509.98-6.8-3.41-19.349-28.83-15.153-5.16 1.073-17.384 3.819-24.964 6.223.916-4.136 2.633-12.844 2.166-14.586 12.976-.987 40.968-10.697 49.128-41.642 2.1-9.59 4.46-32.851-2.9-49.179-2.39-5.429-7.2-16.746-7.32-18.582-1.88-5.876-10.43-13.825-29.534 1.378-4.503 3.541-14.833 12.659-20.128 20.8-1.224-3.407-4.145-10.934-6.032-13.79 7.971-5.715 22.992-23.715 19.315-49.995-1.608-8.907-8.018-29.226-20.797-39.247-8.244-6.351-23.859-19.285-25.081-20.358l-.154-.138-.015-.013h-.001c-1.295-1.163-5.838-5.243-12.482-3.462-14.823 3.971-35.808 53.667 3.504 105.507 9.094 13.593 27.155 47.628 26.646 75.03 2.172 20.894-2.279 72.415-37.456 111.347-1.513 1.836-4.136 5.69-6.388 10.582l-52.137 13.97-13.593-50.727 55.617 9.379c5.547.936 9.989-4.545 7.92-9.772l-27.015-68.238a7.21 7.21 0 0 1 .316-5.998l34.037-65.055c2.607-4.983-1.236-10.896-6.85-10.542l-73.311 4.616a7.23 7.23 0 0 1-5.611-2.151l-51.387-52.421c-3.936-4.015-10.753-2.188-12.154 3.257l-18.293 71.091a7.22 7.22 0 0 1-3.784 4.668l-65.796 32.658c-5.04 2.501-5.411 9.543-.662 12.555l62.005 39.321a7.21 7.21 0 0 1 3.273 5.036l10.723 72.604c.821 5.561 7.409 8.086 11.745 4.503l43.476-35.931 13.592 50.727-51.421 13.778c-4.396-3.111-8.595-5.136-10.824-5.97-49.93-16.128-79.545-58.521-88.111-77.702-14.141-23.476-15.518-61.982-14.439-78.3m159.555 201.888c-6.261 1.677-9.977 8.108-8.301 14.363s8.11 9.965 14.371 8.288l73.247-19.627c6.261-1.678 9.977-8.108 8.301-14.363s-8.11-9.966-14.37-8.288z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#achievements-bg_svg__c)",
  fillRule: "evenodd",
  d: "M216.85 251.092c-6.218-11.351-18.4-27.622-35.418-41.061-17.086-13.493-39.923-24.79-67.06-24.203l-.406.009-.406.034c-15.296 1.29-25.217 14.013-30.68 25.017-5.866 11.815-9.159 26.445-9.143 39.868.016 12.94 2.707 24.331 10.87 32.597 7.872 7.973 18.59 10.657 28.514 11.978 7.15.953 15.709 1.369 24.77 1.809 3.476.169 7.025.341 10.595.549 13.368.777 28.555 2.082 45.673 5.382l11.878 2.291.048-.182 60.337 16.168-.049.181 11.432 3.955c16.474 5.701 30.279 12.164 42.245 18.175 3.196 1.606 6.355 3.231 9.449 4.822 8.068 4.15 15.688 8.069 22.356 10.819 9.256 3.817 19.88 6.852 30.684 3.884 11.202-3.078 19.228-11.597 25.711-22.795 6.726-11.617 11.19-25.933 12.017-39.099.771-12.26-1.459-28.239-14.062-37.005l-.334-.232-.347-.211c-23.208-14.077-48.634-15.712-70.177-12.57-21.458 3.13-40.143 11.129-51.204 17.851l-2.278 1.384a52.3 52.3 0 0 0-29.036-20.053 52.3 52.3 0 0 0-34.847 2.704zm-110.696-28.65c4.148-8.357 7.993-10.365 9.371-10.646 19.07-.244 35.972 7.704 49.803 18.627 11.86 9.366 20.833 20.444 26.164 28.826l-4.353 16.244c-13.827-2.122-26.251-3.111-37.144-3.744-4.376-.255-8.382-.449-12.079-.629-8.491-.412-15.359-.746-21.364-1.545-8.588-1.144-11.91-2.914-13.457-4.479-1.256-1.272-3.362-4.505-3.373-14.371-.012-9.6 2.438-20.239 6.432-28.283m285.388 63.312c1.052.932 3.378 4.594 2.792 13.906-.563 8.963-3.76 19.401-8.571 27.709-4.943 8.539-8.383 10.285-10.107 10.759-2.122.583-5.884.454-13.893-2.849-5.601-2.31-11.715-5.455-19.275-9.344-3.292-1.693-6.858-3.527-10.775-5.495-9.75-4.898-21.004-10.253-34.04-15.33l4.353-16.244c8.807-4.593 22.117-9.701 37.071-11.881 17.44-2.544 36.052-.977 52.445 8.769",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#achievements-bg_svg__d)",
  d: "m17.449 281.534 180.92 48.477-24.379 90.983-212.293-56.884 15.972-59.609c4.643-17.327 22.453-27.61 39.78-22.967"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#achievements-bg_svg__e)",
  d: "m447.985 494.411-211.248-56.604 24.379-90.983 179.874 48.197c17.327 4.643 27.61 22.453 22.967 39.78z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#achievements-bg_svg__f)",
  d: "m166.144 450.276-181.966-48.758-57.444 214.385c-4.643 17.328 5.64 35.138 22.967 39.78l150.592 40.351z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#achievements-bg_svg__g)",
  d: "m163.04 712.847 65.851-245.758 181.966 48.758-57.445 214.385c-4.642 17.327-22.453 27.609-39.779 22.967z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#achievements-bg_svg__h)",
  d: "M868.11 63.105c31.421-11.867 47.286-46.924 35.436-78.301s-46.929-47.194-78.35-35.328C793.774-38.657 777.909-3.6 789.759 27.777s46.929 47.195 78.351 35.328"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#achievements-bg_svg__i)",
  fillRule: "evenodd",
  d: "m793.011-135.745 31.762 10.224 26.751-19.969 25.417 21.592 32.355-8.229 15.202 29.672 33.033 4.763 2.673 33.235 28.682 17.03-10.264 31.74 19.965 26.704-21.638 25.41 8.208 32.314-29.717 15.214-4.798 33.003-33.273 2.7-17.074 28.668-31.763-10.224-26.751 19.969-25.417-21.592-32.355 8.229-15.201-29.672-33.033-4.763-2.674-33.235-28.681-17.03 10.263-31.74-19.964-26.704 21.637-25.41-8.208-32.314 29.717-15.214 4.798-33.002 33.273-2.701zM928.282-24.538c17.003 45.02-5.76 95.318-50.843 112.345-45.084 17.026-95.413-5.668-112.416-50.688-17.002-45.02 5.761-95.318 50.844-112.344 45.083-17.027 95.412 5.667 112.415 50.687",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#achievements-bg_svg__j)",
  d: "m854.127 175.758-15.081 91.647-39.241-43.919-53.367 28.794 16.612-100.953 10.755 20.991 36.313-9.236 28.527 24.233z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#achievements-bg_svg__k)",
  d: "m1085.67 124.414-78.33-64.052 5.57 21.904-33.355 17.075-5.386 37.041-20.098 1.631 72.109 58.968.41-58.894z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#achievements-bg_svg__l)",
  d: "M403.588 133.783c-4.499-3.162-4.749-9.741-.503-13.234l79.061-65.046c4.232-3.481 10.615-1.992 12.871 3.002l27.114 60.035c8.059 17.842 3.157 38.869-11.959 51.305"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#achievements-bg_svg__m)",
  d: "M515.532 250.031a8.32 8.32 0 0 1 1.138-11.713l59.114-48.635a8.32 8.32 0 0 1 11.713 1.141l9.253 11.246a8.32 8.32 0 0 1-1.139 11.713l-59.114 48.634a8.32 8.32 0 0 1-11.713-1.14z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#achievements-bg_svg__n)",
  d: "m501.793 184.822 24.369 33.601 28.272-23.26-28.191-30.295a56.2 56.2 0 0 1-10.627 11.582 56.2 56.2 0 0 1-13.823 8.372"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#achievements-bg_svg__o)",
  d: "m403.5 144.993-18.127 14.914c-3.534 2.907-4.078 8.133-.849 11.376 17.029 17.103 50.683 37.592 84.485 16.412a56.2 56.2 0 0 1-15.762-7.735l-.343-.241c-13.401 5.005-36.73 2.37-54.554-14.594l15.569-12.809z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#achievements-bg_svg__p)",
  d: "m505.965 60.693 18.127-14.913c3.533-2.907 8.766-2.434 11.326 1.359 13.502 20.005 27.122 56.977-.175 86.064a56.2 56.2 0 0 0-4.553-16.957l-.171-.383c7.494-12.186 9.404-35.585-3.807-56.344l-15.569 12.81z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#achievements-bg_svg__q)",
  d: "M125.959-29.35c-4.334-3.593-10.934-1.27-12.061 4.246l-10.19 49.868a7.45 7.45 0 0 1-1.565 3.266L69.65 67.207c-3.594 4.333-1.27 10.934 4.245 12.061l49.868 10.19a7.45 7.45 0 0 1 3.266 1.565l39.178 32.492c4.333 3.594 10.934 1.271 12.061-4.245l10.189-49.868a7.47 7.47 0 0 1 1.566-3.266l32.492-39.177c3.594-4.333 1.271-10.934-4.245-12.061l-49.868-10.19a7.46 7.46 0 0 1-3.266-1.565z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#achievements-bg_svg__r)",
  d: "m170.406-3.66-13.719-11.378 17.682-11.681c4.697-3.104 11.007-.08 11.53 5.526l1.968 21.1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#achievements-bg_svg__s)",
  d: "M95.34 22.76 98.908 5.3l-21.1 1.968c-5.606.523-8.631 6.833-5.528 11.53L83.962 36.48z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#achievements-bg_svg__t)",
  d: "m106.267 115.359-1.968-21.1 17.461 3.567 13.719 11.378-17.682 11.681c-4.697 3.104-11.007.079-11.53-5.526"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#achievements-bg_svg__u)",
  d: "m214.359 86.9-21.101 1.967 3.568-17.461 11.378-13.718 11.681 17.68c3.104 4.698.079 11.008-5.526 11.531"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#achievements-bg_svg__v)",
  d: "M688.218 217.491c.001-1.722-1.833-2.824-3.352-2.014l-13.735 7.325a2.3 2.3 0 0 1-1.075.268l-15.566-.014c-1.722-.002-2.823 1.833-2.013 3.352l7.324 13.735c.177.331.269.7.268 1.075l-.014 15.565c-.001 1.722 1.833 2.824 3.352 2.014l13.735-7.325a2.3 2.3 0 0 1 1.075-.268l15.566.014c1.722.002 2.823-1.833 2.013-3.352l-7.324-13.735a2.26 2.26 0 0 1-.268-1.074z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#achievements-bg_svg__w)",
  d: "m690.834 232.971.005-5.45 6.2 1.887c1.647.501 2.165 2.578.947 3.794l-4.587 4.579z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#achievements-bg_svg__x)",
  d: "m669.971 220.44 4.809-2.565-4.579-4.587c-1.216-1.218-3.292-.7-3.794.947l-1.887 6.2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#achievements-bg_svg__y)",
  d: "m650.288 241.072 4.586-4.578 2.565 4.809-.005 5.45-6.2-1.887c-1.647-.501-2.165-2.578-.946-3.794"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#achievements-bg_svg__z)",
  d: "m678.072 260.986-4.579-4.587 4.809-2.565 5.451.005-1.887 6.201c-.502 1.647-2.578 2.165-3.794.946"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#achievements-bg_svg__A)",
  d: "M312.468 148.965c-.703-2.337-3.645-3.082-5.375-1.359l-15.643 15.569c-.377.375-.84.651-1.349.805l-21.136 6.357c-2.338.704-3.082 3.645-1.36 5.376l15.57 15.643c.375.377.651.84.804 1.349l6.358 21.135c.703 2.338 3.645 3.082 5.375 1.36l15.644-15.57c.376-.375.84-.651 1.349-.804l21.135-6.358c2.338-.703 3.082-3.645 1.36-5.375l-15.57-15.643a3.2 3.2 0 0 1-.804-1.349z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#achievements-bg_svg__B)",
  d: "m322.361 168.907-2.226-7.401 9.19.022c2.441.006 3.995 2.612 2.839 4.763l-4.351 8.094z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#achievements-bg_svg__C)",
  d: "m288.907 160.444 5.478-5.452-8.095-4.35c-2.15-1.156-4.756.398-4.762 2.839l-.022 9.189z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#achievements-bg_svg__D)",
  d: "m270.641 196.515 4.351-8.094 5.452 5.478 2.226 7.4-9.189-.021c-2.441-.006-3.995-2.612-2.84-4.763"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#achievements-bg_svg__E)",
  d: "m316.515 212.164-8.094-4.351 5.477-5.451 7.401-2.227-.022 9.19c-.005 2.441-2.612 3.995-4.762 2.839"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#achievements-bg_svg__F)",
  d: "M529.363 475.609c-.102-1.842-2.131-2.911-3.708-1.952l-14.255 8.665a2.44 2.44 0 0 1-1.134.351l-16.657.923c-1.842.102-2.911 2.131-1.952 3.708l8.665 14.256c.208.343.329.732.351 1.133l.923 16.657c.102 1.843 2.131 2.911 3.708 1.953l14.255-8.665a2.44 2.44 0 0 1 1.134-.352l16.657-.922c1.843-.102 2.911-2.132 1.953-3.709l-8.665-14.255a2.44 2.44 0 0 1-.352-1.134z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#achievements-bg_svg__G)",
  d: "m533.095 492.016-.323-5.832 6.748 1.646c1.793.437 2.472 2.627 1.242 4.002l-4.633 5.176z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#achievements-bg_svg__H)",
  d: "m510.016 479.864 4.992-3.034-5.176-4.632c-1.375-1.231-3.565-.552-4.003 1.241l-1.645 6.748z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#achievements-bg_svg__I)",
  d: "m490.198 503.127 4.632-5.175 3.034 4.991.323 5.833-6.748-1.646c-1.793-.437-2.472-2.628-1.241-4.003"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#achievements-bg_svg__J)",
  d: "m521.127 522.762-5.175-4.632 4.991-3.035 5.833-.323-1.646 6.748c-.437 1.793-2.628 2.473-4.003 1.242"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#achievements-bg_svg__K)",
  d: "m401.101 26.629.382 14.589L411.938 51.4l-13.757 4.871-6.453 13.09-8.884-11.578-14.443-2.092 8.266-12.027-2.474-14.383 13.993 4.145z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#achievements-bg_svg__L)",
  d: "m56.1 134.629.383 14.589L66.938 159.4l-13.757 4.871-6.453 13.09-8.884-11.578-14.443-2.092 8.265-12.027-2.473-14.383 13.993 4.145z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#achievements-bg_svg__M)",
  d: "m319.101 49.629.382 14.589L329.938 74.4l-13.757 4.872-6.453 13.09-8.884-11.579-14.443-2.092 8.266-12.027-2.474-14.383 13.993 4.145z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#achievements-bg_svg__N)",
  d: "m518.101 322.629.382 14.589 10.455 10.182-13.757 4.871-6.453 13.09-8.884-11.578-14.443-2.092 8.266-12.027-2.474-14.383 13.993 4.145z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#achievements-bg_svg__O)",
  d: "m662.101 66.629.382 14.589L672.938 91.4l-13.757 4.872-6.453 13.089-8.884-11.578-14.443-2.092 8.266-12.027-2.474-14.383 13.993 4.145z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#achievements-bg_svg__P)",
  d: "m555.336 557.833.784 29.901 21.428 20.868-28.195 9.985-13.225 26.828-18.209-23.729-29.603-4.288 16.942-24.651-5.07-29.478 28.68 8.495z"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "achievements-bg_svg__b",
  x1: 505.644,
  x2: 505.644,
  y1: -145.49,
  y2: 637.093,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.976,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "achievements-bg_svg__c",
  x1: 505.644,
  x2: 505.644,
  y1: -145.49,
  y2: 637.093,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.976,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "achievements-bg_svg__d",
  x1: 505.644,
  x2: 505.644,
  y1: -145.49,
  y2: 637.093,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.976,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "achievements-bg_svg__e",
  x1: 505.644,
  x2: 505.644,
  y1: -145.49,
  y2: 637.093,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.976,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "achievements-bg_svg__f",
  x1: 505.644,
  x2: 505.644,
  y1: -145.49,
  y2: 637.093,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.976,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "achievements-bg_svg__g",
  x1: 505.644,
  x2: 505.644,
  y1: -145.49,
  y2: 637.093,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.976,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "achievements-bg_svg__h",
  x1: 505.644,
  x2: 505.644,
  y1: -145.49,
  y2: 637.093,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.976,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "achievements-bg_svg__i",
  x1: 505.644,
  x2: 505.644,
  y1: -145.49,
  y2: 637.093,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.976,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "achievements-bg_svg__j",
  x1: 505.644,
  x2: 505.644,
  y1: -145.49,
  y2: 637.093,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.976,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "achievements-bg_svg__k",
  x1: 505.644,
  x2: 505.644,
  y1: -145.49,
  y2: 637.093,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.976,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "achievements-bg_svg__l",
  x1: 505.644,
  x2: 505.644,
  y1: -145.49,
  y2: 637.093,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.976,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "achievements-bg_svg__m",
  x1: 505.644,
  x2: 505.644,
  y1: -145.49,
  y2: 637.093,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.976,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "achievements-bg_svg__n",
  x1: 505.644,
  x2: 505.644,
  y1: -145.49,
  y2: 637.093,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.976,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "achievements-bg_svg__o",
  x1: 505.644,
  x2: 505.644,
  y1: -145.49,
  y2: 637.093,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.976,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "achievements-bg_svg__p",
  x1: 505.644,
  x2: 505.644,
  y1: -145.49,
  y2: 637.093,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.976,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "achievements-bg_svg__q",
  x1: 505.644,
  x2: 505.644,
  y1: -145.49,
  y2: 637.093,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.976,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "achievements-bg_svg__r",
  x1: 505.644,
  x2: 505.644,
  y1: -145.49,
  y2: 637.093,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.976,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "achievements-bg_svg__s",
  x1: 505.644,
  x2: 505.644,
  y1: -145.49,
  y2: 637.093,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.976,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "achievements-bg_svg__t",
  x1: 505.644,
  x2: 505.644,
  y1: -145.49,
  y2: 637.093,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.976,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "achievements-bg_svg__u",
  x1: 505.644,
  x2: 505.644,
  y1: -145.49,
  y2: 637.093,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.976,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "achievements-bg_svg__v",
  x1: 505.644,
  x2: 505.644,
  y1: -145.49,
  y2: 637.093,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.976,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "achievements-bg_svg__w",
  x1: 505.644,
  x2: 505.644,
  y1: -145.49,
  y2: 637.093,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.976,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "achievements-bg_svg__x",
  x1: 505.644,
  x2: 505.644,
  y1: -145.49,
  y2: 637.093,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.976,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "achievements-bg_svg__y",
  x1: 505.644,
  x2: 505.644,
  y1: -145.49,
  y2: 637.093,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.976,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "achievements-bg_svg__z",
  x1: 505.644,
  x2: 505.644,
  y1: -145.49,
  y2: 637.093,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.976,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "achievements-bg_svg__A",
  x1: 505.644,
  x2: 505.644,
  y1: -145.49,
  y2: 637.093,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.976,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "achievements-bg_svg__B",
  x1: 505.644,
  x2: 505.644,
  y1: -145.49,
  y2: 637.093,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.976,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "achievements-bg_svg__C",
  x1: 505.644,
  x2: 505.644,
  y1: -145.49,
  y2: 637.093,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.976,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "achievements-bg_svg__D",
  x1: 505.644,
  x2: 505.644,
  y1: -145.49,
  y2: 637.093,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.976,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "achievements-bg_svg__E",
  x1: 505.644,
  x2: 505.644,
  y1: -145.49,
  y2: 637.093,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.976,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "achievements-bg_svg__F",
  x1: 505.644,
  x2: 505.644,
  y1: -145.49,
  y2: 637.093,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.976,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "achievements-bg_svg__G",
  x1: 505.644,
  x2: 505.644,
  y1: -145.49,
  y2: 637.093,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.976,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "achievements-bg_svg__H",
  x1: 505.644,
  x2: 505.644,
  y1: -145.49,
  y2: 637.093,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.976,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "achievements-bg_svg__I",
  x1: 505.644,
  x2: 505.644,
  y1: -145.49,
  y2: 637.093,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.976,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "achievements-bg_svg__J",
  x1: 505.644,
  x2: 505.644,
  y1: -145.49,
  y2: 637.093,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.976,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "achievements-bg_svg__K",
  x1: 505.644,
  x2: 505.644,
  y1: -145.49,
  y2: 637.093,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.976,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "achievements-bg_svg__L",
  x1: 505.644,
  x2: 505.644,
  y1: -145.49,
  y2: 637.093,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.976,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "achievements-bg_svg__M",
  x1: 505.644,
  x2: 505.644,
  y1: -145.49,
  y2: 637.093,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.976,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "achievements-bg_svg__N",
  x1: 505.644,
  x2: 505.644,
  y1: -145.49,
  y2: 637.093,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.976,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "achievements-bg_svg__O",
  x1: 505.644,
  x2: 505.644,
  y1: -145.49,
  y2: 637.093,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.976,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "achievements-bg_svg__P",
  x1: 505.644,
  x2: 505.644,
  y1: -145.49,
  y2: 637.093,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.976,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "achievements-bg_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h1008v684H0z"
})))));
export { SvgAchievementsBg as ReactComponent };
export default __webpack_public_path__ + "../icons/0e1ec63007ee50761230f27da3d72f0a.svg";